<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="项目ID" :value="1"></el-option>
                            <el-option label="申购项目名称" :value="2"></el-option>
							<el-option label="关联周边" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.subscriptionStatus" placeholder="请选择" size="small">
                        <el-option label="不限制申购项目状态" value=""></el-option>
                        <el-option label="仅看未开始的" :value="1"></el-option>
                        <el-option label="仅看进行中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isShow" placeholder="请选择" size="small">
				        <el-option label="不限制显示状态" value=""></el-option>
				        <el-option label="仅看显示的" :value="1"></el-option>
				        <el-option label="仅看隐藏的" :value="0"></el-option>				        
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
				                <el-option label="申购开始时间" :value="1"></el-option>
                                <el-option label="创建时间" :value="2"></el-option>				                
				            </el-select>
				        </el-input>
				        <el-date-picker
				            v-model="date"
				            type="datetimerange"
				            start-placeholder="开始时间"
				            end-placeholder="结束时间"
				            class="fl"
				            size="small"
				            :default-time="['00:00:00', '23:59:59']"
				            value-format="yyyy-MM-dd HH:mm:ss"
				            unlink-panels
				            >
				        </el-date-picker>
				    </div>
				</el-col>
				<!-- <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="dateType" slot="prepend" placeholder="请选择">
				                <el-option label="创建时间" :value="1"></el-option>				                
				            </el-select>
				        </el-input>
				        <el-date-picker
				            v-model="date1"
				            type="datetimerange"
				            start-placeholder="开始时间"
				            end-placeholder="结束时间"
				            class="fl"
				            size="small"
				            :default-time="['00:00:00', '23:59:59']"
				            value-format="yyyy-MM-dd HH:mm:ss"
				            unlink-panels
				            >
				        </el-date-picker>
				    </div>
				</el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/subscribe/save')" type="primary" icon="el-icon-plus" size="small" @click="add()">创建申购项目</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="项目ID"></el-table-column>
                <el-table-column prop="name" label="申购项目名称" min-width="200" ></el-table-column>
				<el-table-column prop="subscribeNum" label="申购人数" ></el-table-column>
				<el-table-column prop="winningNum" label="中签人数" ></el-table-column>
				<el-table-column prop="goodsName" label="关联周边" min-width="200">
					<router-link class="category-item" slot-scope="scope" :to="`/goodsManage/goods/edit/${scope.row.goodsId}`" v-if="scope.row.goodsName">
						{{`${scope.row.goodsName}`}}
					</router-link>
					
				</el-table-column>
                <el-table-column label="申购项目状态" prop="subscriptionStatus" min-width="100">
					 <template slot-scope="scope">
					     <span v-if="scope.row.subscriptionStatus == 1">未开始</span>
					     <span v-else-if="scope.row.subscriptionStatus == 2">进行中</span>
					     <span v-else-if="scope.row.subscriptionStatus == 3">已结束</span>
					 </template>   
                </el-table-column>
				<el-table-column label="展示状态" prop="isShow">
					 <template slot-scope="scope">
					     <span v-if="scope.row.isShow == 1">展示</span>
					     <span v-else-if="scope.row.isShow == 0">隐藏</span>
					 </template>   
				</el-table-column>
				<el-table-column label="申购时间" :min-width="180">
				    <template slot-scope="scope">
				        <p>从：{{`${scope.row.startTime}`}}</p>
				        <p>到：{{`${scope.row.endTime}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column label="创建时间" :min-width="180" prop="createTime"></el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/expand/save')" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
                        <template v-if="$utils.have('/subscribe/display')">
                            <el-button
                                v-if="scope.row.isShow == 1"
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,0)"
                                >隐藏</el-button
                            >
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,1)"
                                >显示</el-button
                            >
                        </template>
                        <el-button type="text" size="small" @click="subscribeList(scope.row.id,scope.row.name)">申购名单</el-button>
						<el-button type="text" size="small" @click="copy(scope.row.wapLink)">申购地址</el-button>
                        <el-button v-if="$utils.have('/subscribe/sub/list')" type="text" size="small" @click="$refs.subGoodsList.show(scope.row.id)">子商品</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <input class="copyTool" ref="copyTool" :value="copyUrl" />
        <sub-goods-list ref="subGoodsList"></sub-goods-list>
    </div>
</template>

<script>
import SubGoodsList from './components/SubGoodsList.vue';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    subscriptionStatus: "",
	isShow:'',	
    timeType:1,
}
export default {
    components:{SubGoodsList},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
				isShow: this.$route.query.isShow || "",
                subscriptionStatus: parseInt(this.$route.query.subscriptionStatus) || "",
                timeType: parseInt(this.$route.query.timeType || 1),
            },
            listLoading: true,
			date:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
			// date1:[this.$route.query.createTimeStart || '' , this.$route.query.createTimeEnd || ''],
			sswap:process.env.VUE_APP_SSWAP_URL,
			copyUrl: "",
			copyTimer: null
            
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/subscribe/list",
                method: "POST",
                data: {
                    ...this.params,
					startTime:this.date && this.date[0] || '',
					endTime:this.date && this.date[1] || ''
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                    this.dataList.map(item => {
                        item.wapLink = `${this.sswap}/pages/special/purchase/index?id=${item.id}`
                    })
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.date = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		//判断显示与隐藏
		editStatus(id,status){
		    const _msg = status === 0 ? '确定要隐藏吗?' : '确定要显示吗?';
		    this.$confirm(_msg, '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: '/subscribe/display',
		            method: 'POST',
		            params: {id:id}
		        }).then(res => {
		            const { state, msg } = res.data;
		            if( state == 1 ){
		                this.getDataList();
		            }else{
		                this.$message.error(msg || '请求失败');
		            }
		        }).catch(() => {
		            this.$message.error('请求错误');
		        }).finally(() => {
		            this.listLoading = false;
		        });
		    }).catch(() => {})
		},
        //复制链接
        copy(url){
            clearTimeout(this.copyTimer);
            this.copyUrl = url;
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
       //编辑
        edit(id){
            this.$router.push({
                path: `/promotion/subscribe/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
					
                },
            });
        },
		//申购名单
		subscribeList(id,name){
		    this.$router.push({
		        path: `/promotion/subscribe/subscribeuser/${id}`,				
		        query: {
		            redirect: this.$utils.objArgs(
		                this.$router.currentRoute.path,
		                this.params,						
		            ),
					name:name
					
		        },
		    });
		},
        //新增
        add(){
            this.$router.push({
                path: '/promotion/subscribe/add',
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>